<template>
  <v-container>
    <v-form ref="form" lazy-validation>
      <v-row class="text-left" justify="center">
        <v-col cols="10">
          <v-container fluid>
            <v-row class="text-left" justify="end" align="center">
              <p class="mb-0 mr-3">Language:</p>
              <v-select
                v-model="$i18n.locale"
                :items="langs"
                :item-value="'value'"
                :item-text="'text'"
                style="width: 50px"
                class="select"
                outlined
                hide-details
                dense
              ></v-select>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
      <v-row class="text-center pt-4 mt-4" justify="center">
        <v-col cols="10">
          <v-container>
            <v-row class="text-center">
              <v-col cols="12" md="12" justify="center">
                <h3>
                  {{ $t("title_form") }}
                </h3>
              </v-col>
            </v-row>
            <v-row class="text-left">
              <v-col cols="12">
                <p v-html="`${script1[$i18n.locale]}`"></p>
                <!-- <div
                id="otnotice-6af2e2f3-da0a-4b9c-8aeb-12bcdc3afb49"
                class="otnotice"
              ></div> -->
              </v-col>
            </v-row>
            <v-row class="text-left" align="end">
              <v-col cols="12" md="4">
                <p class="mb-0">{{ $t("employee.code") }}</p>
                <v-text-field
                  class="inputPrice"
                  v-model="employee.code"
                  :label="$t('employee.code')"
                  :rules="employeeRules"
                  outlined
                  single-line
                  hide-details
                  :readonly="!isHr"
                  type="number"
                  @keyup.enter="onSearch"
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-btn
                  block
                  :disabled="!isHr"
                  style="text-transform: none"
                  @click="onSearch"
                  ><v-icon left> mdi-magnify </v-icon> {{ $t("search") }}
                </v-btn>
              </v-col>
              <v-col cols="12" md="3">
                <p class="mb-0">{{ $t("employee.name") }}</p>
                <v-text-field
                  v-model="employee[$i18n.locale].name"
                  outlined
                  single-line
                  hide-details
                  readonly
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <p class="mb-0">{{ $t("employee.surname") }}</p>
                <v-text-field
                  v-model="employee[$i18n.locale].surname"
                  outlined
                  single-line
                  hide-details
                  readonly
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="text-left" align="end">
              <v-col cols="12" md="3">
                <p class="mb-0">
                  {{ $t("employee.company") }}
                </p>
                <v-text-field
                  v-model="employee[$i18n.locale].employeeStructure4Code"
                  outlined
                  single-line
                  hide-details
                  readonly
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="9">
                <v-text-field
                  v-model="employee[$i18n.locale].employeeStructure2NameAlt"
                  outlined
                  single-line
                  hide-details
                  readonly
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="text-left">
              <v-col cols="12" md="12">
                <p class="mb-0">{{ $t("employee.department") }}</p>
                <v-text-field
                  v-model="employee[$i18n.locale].department"
                  outlined
                  single-line
                  hide-details
                  readonly
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="text-left">
              <!-- <v-col cols="12" md="6">
                <p class="mb-0">{{ $t("employee.tel") }}</p>
                <v-text-field
                  v-model="employee[$i18n.locale].tel"
                  outlined
                  single-line
                  hide-details
                  readonly
                  dense
                ></v-text-field>
              </v-col> -->
              <v-col cols="12" md="12">
                <p class="mb-0">{{ $t("employee.email") }}</p>
                <v-text-field
                  v-model="employee[$i18n.locale].email"
                  outlined
                  single-line
                  hide-details
                  readonly
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="text-left" align="end">
              <v-col cols="12" md="6">
                <p v-if="isHr && !checkEmail" class="mb-0">
                  {{ $t("employee.attachment.text") }}
                  <!-- <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon color="grey lighten-1"> mdi-alert-circle </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("employee.attachment.tooltip") }}</span>
                </v-tooltip> -->
                </p>
                <v-file-input
                  v-if="!checkEmail && isHr"
                  class="pt-0 mt-0"
                  :placeholder="$t('employee.attachment.text')"
                  @change="onChangeFile()"
                  v-model="dataFile.file"
                  accept="application/pdf"
                  clearable
                  prepend-icon="mdi-paperclip"
                />
              </v-col>
              <v-col cols="12" md="6" justify="center">
                <p v-if="!checkEmail && isHr">
                  {{ $t("employee.attachment.details") }}
                </p></v-col
              >
            </v-row>
            <v-row class="text-left">
              <v-col cols="12" md="12" justify="center">
                <p>
                  {{ $t("note") }}
                </p>
              </v-col>
            </v-row>
            <v-row class="pt-0 mt-0" justify="center">
              <v-card
                class="text-left ma-2 overflow-auto"
                elevation="3"
                :height="purpose[$i18n.locale] == '' ? '0px' : '500px'"
              >
                <vue-custom-scrollbar class="scroll-area">
                  <v-card-text class="pa-8"
                    ><span style="white-space: pre-line">{{
                      purpose[$i18n.locale]
                    }}</span></v-card-text
                  >
                </vue-custom-scrollbar>
              </v-card>
            </v-row>
            <v-row class="text-left">
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="check.accept"
                  @click="onCheck($event)"
                  :label="$t('accept')"
                  color="success"
                  readonly
                  hide-details
                ></v-checkbox> </v-col
            ></v-row>
            <v-row class="text-left">
              <v-col cols="12">
                <p v-html="`${script2[$i18n.locale]}`"></p>
                <!-- <div
                id="otnotice-f8208263-8f14-457a-8b3b-cf2b6f6a5dcb"
                class="otnotice"
              ></div> -->
              </v-col>
            </v-row>
            <v-row class="text-left">
              <v-col cols="12">
                <v-btn
                  @click="onsubmit"
                  :disabled="check.purpose && check.accept ? false : true"
                  color="success"
                >
                  {{ $t("submit") }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="text-left">
              <v-col cols="12">
                <p class="grey--text" v-html="`${script3[$i18n.locale]}`"></p>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
      <MessageError
        :visible="showMessageError"
        :textError="textError"
        @close="showMessageError = false"
      />
      <MessageSuccess :visible="showMessageSuccess" :textMsg="textSuccess" />
      <LoadingPage v-if="loading" />
    </v-form>
  </v-container>
</template>
<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
import OnetrustService from "../services/onetrustService";
// import EmployeeService from "../services/employeeService";
import OauthService from "../services/oauthService";
import axios from "axios";
import { keys } from "vuetify/lib/util/helpers";
import MessageError from "@/components/message-error.vue";
import LoadingPage from "../components/loading-page.vue";
import MessageSuccess from "@/components/message-success.vue";
import { validateId } from "@/services/auth.service";
// import getAuth from "@/service/getUserService";

export default {
  name: "HelloWorld",
  components: {
    vueCustomScrollbar,
    MessageError,
    LoadingPage,
    MessageSuccess,
  },
  data: () => ({
    // uuu: this.$configurl,
    script1: { en: "", th: "" },
    script2: { en: "", th: "" },
    script3: { en: "", th: "" },
    showMessageError: false,
    showMessageSuccess: false,
    textError: "",
    textSuccess: "",
    loading: false,
    dataFile: {
      file: null,
    },
    dataEmployee: null,
    dataUser: null,
    isHr: false,
    checkEmail: false,
    employee: {
      code: "",
      plantCode: "",
      en: {
        name: "",
        surname: "",
        employeeStructure4Code: "",
        employeeStructure2NameAlt: "",
        department: "",
        tel: "",
        email: "",
      },
      th: {
        name: "",
        surname: "",
        employeeStructure4Code: "",
        employeeStructure2NameAlt: "",
        department: "",
        tel: "",
        email: "",
      },
    },
    purpose: {
      en: "",
      th: "",
    },
    check: {
      purpose: false,
      accept: false,
    },

    langs: [
      {
        value: "th",
        text: "TH",
      },
      {
        value: "en",
        text: "EN",
      },
    ],
    employeeRules: [
      (v) => !!v || "กรอกรหัสพนักงาน",
      (v) => v.length <= 8 || "8",
    ],
  }),
  async mounted() {
    await this.getAuth();
  },

  methods: {
    async getAuth() {
      this.loading = true;
      const idapp = localStorage.getItem("idapp") ?? "";
      const tokenapp = this.$tokenOauth;

      const resultvalidateId = await validateId(idapp, tokenapp);
      if (resultvalidateId.token && resultvalidateId.accessToken) {
        if (localStorage.check) {
          localStorage.check = "";
          if (resultvalidateId.id) {
            this.login2(resultvalidateId.id);
          } else {
            console.log(resultvalidateId);
            this.msgError("can't find Id");
          }
        } else {
          localStorage.check = "1";
          let token = resultvalidateId.token;
          let acctoken = resultvalidateId.accessToken;
          let data = { accesstoken: acctoken };
          localStorage.token = token;
          axios.defaults.headers["Authorization"] = `Bearer ${token}`;
          await axios
            .post("/sylogin/auth", data)
            .then(async (result) => {
              if (result.data.code == 200) {
                var accesstoken = result.data.data.accesstoken;
                this.dataUser = result.data.data.user;
                this.dataUser.DepartmentNameAlt =
                  result.data.data.MSEmployee[0].DepartmentNameAlt;
                axios.defaults.headers[
                  "Authorization"
                ] = `Bearer ${accesstoken}`;
                await axios
                  .get("/suppservice/onetrust/notices")
                  .then((result) => {
                    if (result.data.code == 200) {
                      let data = result.data.data;
                      this.script1.th = data.PartA.th.content;
                      this.script1.en = data.PartA.en.content;

                      this.script2.th = data.PartB.th.content;
                      this.script2.en = data.PartB.en.content;

                      this.script3.th = data.PartC.th.content;
                      this.script3.en = data.PartC.en.content;
                    }
                  });
                await axios
                  .get("/suppservice/onetrust/purpose")
                  .then((result) => {
                    if (result.data.code == 200) {
                      let data = result.data.data.languages;
                      switch (data[0].language) {
                        case "th":
                          this.purpose.th = data[0].description;
                          this.purpose.en = data[1].description;
                          break;

                        case "en":
                          this.purpose.th = data[1].description;
                          this.purpose.en = data[0].description;
                          break;

                        default:
                          this.msgError(this.$t("msgerror.nolang"));
                          break;
                      }
                      if (data != undefined) {
                        this.check.purpose = true;
                      }
                    } else {
                      this.msgError(this.$t("msgerror.connection"));
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                    this.msgError(this.$t("msgerror.connection"));
                  });

                // this.isHr = true; //test

                if (this.dataUser.DepartmentNameAlt == "Human Resources") {
                  this.isHr = true;
                } else {
                  // this.isHr = true; //test
                  this.isHr = false;
                  this.employee.code = this.dataUser.EmployeeCode;
                  this.getEmployee();
                }
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }

        // this.getPurpose();

        // axios.defaults.headers['Authorization'] = `Bearer ${result.data.token}`;
      } else {
        localStorage.check = "";
        const idapp = resultvalidateId.id;
        // this.login();
        this.login2(idapp);
      }
      this.loading = false;
    },
    login2(idapp) {
      const SRITRANG_LOGIN_URL = this.$urlLoginOauth;

      let token = idapp;
      let urlstaoauth = SRITRANG_LOGIN_URL;
      var form = document.createElement("form");
      form.method = "GET";
      form.action = urlstaoauth;

      var localtoken = document.createElement("input");
      localtoken.name = "localid";
      localtoken.value = token;
      localtoken.type = "hidden";
      form.appendChild(localtoken);

      document.body.appendChild(form);
      form.submit();
    },

    login() {
      const SRITRANG_LOGIN_URL = this.$urlLoginOauth;
      const SRITRANG_LOGIN_TOKEN = this.$tokenOauth;

      let token = SRITRANG_LOGIN_TOKEN;
      let urlstaoauth = SRITRANG_LOGIN_URL;
      var form = document.createElement("form");
      form.method = "GET";
      form.action = urlstaoauth;

      var localtoken = document.createElement("input");
      localtoken.name = "localtoken";
      localtoken.value = token;
      localtoken.type = "hidden";
      form.appendChild(localtoken);

      document.body.appendChild(form);
      form.submit();
    },
    async getAccessToken() {
      let data = {
        token: process.env.VUE_APP_OAUTH_TOKEN,
      };
      await OauthService.getAccessToken(data)
        .then((result) => {
          if (result.data.code == 200) {
            if (
              result.data.data.accessToken != null &&
              result.data.data.accessToken != ""
            ) {
              var accesstoken = result.data.data.accessToken;
              localStorage.setItem("accesstoken", accesstoken);
            } else {
              this.msgError(this.$t("msgerror.tokenemty"));
            }
          } else {
            this.msgError(this.$t("msgerror.connection"));
          }
        })
        .catch((err) => {
          console.log(err);
          this.msgError(this.$t("msgerror.connection"));
        });
    },

    async getPurpose() {
      // await this.getAccessToken();
      await OnetrustService.getPurpose()
        .then((result) => {
          if (result.data.code == 200) {
            // console.log(result.data.data);
            let data = result.data.data.languages;
            // console.log(data);
            switch (data[0].language) {
              case "th":
                this.purpose.th = data[0].description;
                this.purpose.en = data[1].description;
                break;

              case "en":
                this.purpose.th = data[1].description;
                this.purpose.en = data[0].description;
                break;

              default:
                this.msgError(this.$t("msgerror.nolang"));
                break;
            }
            if (data != undefined) {
              this.check.purpose = true;
            }
          } else {
            this.msgError(this.$t("msgerror.connection"));
          }
        })
        .catch((err) => {
          console.log(err);
          this.msgError(this.$t("msgerror.connection"));
        });
    },
    onCheck() {
      if (this.check.accept) {
        this.check.accept = !this.check.accept;
      } else {
        if (
          !this.employee[this.$i18n.locale].email.trim() &&
          !this.dataFile.file
        ) {
          this.msgError(this.$t("msgerror.checkemail"));
        } else {
          this.check.accept = !this.check.accept;
        }
      }
    },

    onChangeFile() {
      this.check.accept = false;
    },

    onSearch() {
      if (this.$refs.form.validate()) {
        this.clearData();
        this.getEmployee();
      } else {
        this.msgError(this.$t("msgerror.nodata"));
        this.clearData();
      }
    },

    clearData() {
      this.employee.plantCode = "";

      this.employee.th.name = "";
      this.employee.th.surname = "";
      this.employee.th.employeeStructure4Code = "";
      this.employee.th.employeeStructure2NameAlt = "";
      this.employee.th.department = "";
      this.employee.th.tel = "";
      this.employee.th.email = "";

      this.employee.en.name = "";
      this.employee.en.surname = "";
      this.employee.en.employeeStructure4Code = "";
      this.employee.en.employeeStructure2NameAlt = "";
      this.employee.en.department = "";
      this.employee.en.tel = "";
      this.employee.en.email = "";

      this.dataFile.file = null;
      this.check.accept = false;
      // this.$refs.form.reset();
    },

    clearDataAll() {
      this.employee.code = "";
      this.employee.plantCode = "";

      this.employee.th.name = "";
      this.employee.th.surname = "";
      this.employee.th.employeeStructure4Code = "";
      this.employee.th.employeeStructure2NameAlt = "";
      this.employee.th.department = "";
      this.employee.th.tel = "";
      this.employee.th.email = "";

      this.employee.en.name = "";
      this.employee.en.surname = "";
      this.employee.en.employeeStructure4Code = "";
      this.employee.en.employeeStructure2NameAlt = "";
      this.employee.en.department = "";
      this.employee.en.tel = "";
      this.employee.en.email = "";

      this.dataFile.file = null;
      this.check.accept = false;
      // this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },

    async getEmployee() {
      let code = this.employee.code;
      await axios
        .get("/msemployeesp/getByIdEmployee/" + code.toString())
        .then((result) => {
          if (result.data.result == "success") {
            if (result.data.data.count > 0) {
              this.dataEmployee = result.data.data.rows[0];

              this.employee.plantCode =
                this.dataEmployee.PlantCode == null
                  ? ""
                  : this.dataEmployee.PlantCode;
              //th
              this.employee.th.name =
                this.dataEmployee.EmployeeFirstName == null
                  ? ""
                  : this.dataEmployee.EmployeeFirstName;
              this.employee.th.surname =
                this.dataEmployee.EmployeeLastName == null
                  ? ""
                  : this.dataEmployee.EmployeeLastName;
              this.employee.th.employeeStructure4Code =
                this.dataEmployee.EmployeeStructure4Code == null
                  ? ""
                  : this.dataEmployee.EmployeeStructure4Code;
              this.employee.th.employeeStructure2NameAlt =
                this.dataEmployee.EmployeeStructure2NameAlt == null
                  ? ""
                  : this.dataEmployee.EmployeeStructure2NameAlt;
              this.employee.th.department =
                this.dataEmployee.DepartmentNameAlt == null
                  ? ""
                  : this.dataEmployee.DepartmentNameAlt;
              this.employee.th.tel =
                this.dataEmployee.EmployeeTelephone1 == null
                  ? ""
                  : this.dataEmployee.EmployeeTelephone1;
              this.employee.th.email =
                this.dataEmployee.EmployeeEmail1 == null
                  ? ""
                  : this.dataEmployee.EmployeeEmail1.trim();

              //en
              this.employee.en.name =
                this.dataEmployee.EmployeeFirstName == null
                  ? ""
                  : this.dataEmployee.EmployeeFirstName_Alt;
              this.employee.en.surname =
                this.dataEmployee.EmployeeLastName == null
                  ? ""
                  : this.dataEmployee.EmployeeLastName_Alt;
              this.employee.en.employeeStructure4Code =
                this.dataEmployee.EmployeeStructure4Code == null
                  ? ""
                  : this.dataEmployee.EmployeeStructure4Code;
              this.employee.en.employeeStructure2NameAlt =
                this.dataEmployee.EmployeeStructure2NameAlt == null
                  ? ""
                  : this.dataEmployee.EmployeeStructure2NameAlt;
              this.employee.en.department =
                this.dataEmployee.DepartmentNameAlt == null
                  ? ""
                  : this.dataEmployee.DepartmentNameAlt;
              this.employee.en.tel =
                this.dataEmployee.EmployeeTelephone1 == null
                  ? ""
                  : this.dataEmployee.EmployeeTelephone1;
              this.employee.en.email =
                this.dataEmployee.EmployeeEmail1 == null
                  ? ""
                  : this.dataEmployee.EmployeeEmail1.trim();
              if (this.employee[this.$i18n.locale].email.trim()) {
                this.checkEmail = true;
              } else {
                this.checkEmail = false;
              }
            } else {
              this.msgError(this.$t("msgerror.nodata"));
              this.clearData();
            }
          } else {
            this.msgError(this.$t("msgerror.nodata"));
            this.clearData();
          }
        })
        .catch((err) => {
          console.log(err);
          this.msgError(this.$t("connection"));
          this.clearData();
        });
    },

    getHerder() {
      OnetrustService.headerForm()
        .then(async (result) => {
          if (result.status == 200) {
            let policyUrl = result.data.languages[this.$i18n.locale].policyUrl;
            this.script1 = await this.getPolicyUrl(policyUrl);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getFooter1() {
      OnetrustService.footer1Form()
        .then(async (result) => {
          if (result.status == 200) {
            let policyUrl = result.data.languages[this.$i18n.locale].policyUrl;
            this.script2 = await this.getPolicyUrl(policyUrl);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getFooter2() {
      OnetrustService.footer2Form()
        .then(async (result) => {
          if (result.status == 200) {
            let policyUrl = result.data.languages[this.$i18n.locale].policyUrl;
            this.script3 = await this.getPolicyUrl(policyUrl);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    changeLanguage() {
      this.getHerder();
      this.getFooter1();
      this.getFooter2();
    },
    async onsubmit() {
      if (this.employee.code != "" && this.employee.en.name != "") {
        this.loading = true;
        let data = {
          EmployeeCode: this.employee.code,
          PlantCode: this.employee.plantCode,
          EmployeeFirstName_Alt: this.employee.en.name,
          EmployeeLastName_Alt: this.employee.en.surname,
          EmployeeStructure4Code: this.employee.en.employeeStructure4Code,
          Language: this.$i18n.locale,
          FirstName: this.employee.en.name,
          LastName: this.employee.en.surname,
          Department: this.employee.en.department,
          Company:
            this.employee.en.employeeStructure4Code +
            "_" +
            this.employee.en.employeeStructure2NameAlt,
          MobileNumber: "",
          Email: this.employee.en.email,
        };
        // console.log(data);

        setTimeout(() => (this.loading = false), 5000);

        await OnetrustService.updateConsentData(data, this.dataFile.file)
          .then((result) => {
            // console.log(result);
            if (result.status == 200) {
              this.loading = false;
              if (this.isHr) {
                this.msgSuccess(this.$t("msgsuccess.success"));
                setTimeout(() => (this.showMessageSuccess = false), 2000);
                this.clearDataAll();
              } else {
                this.successChangePage(this.$t("msgsuccess.success"));
              }
            } else {
              this.loading = false;
              this.msgError(this.$t("msgerror.savefail"));
            }
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
            this.msgError(this.$t("msgerror.savefail"));
          });
      } else {
        this.msgError(this.$t("msgerror.nodata"));
        this.clearData();
      }
    },

    successChangePage(msg) {
      const SRITRANG_LOGIN_URL_SUCCESS = this.$urlLoginOauth;

      let urlstaoauthsuccess = SRITRANG_LOGIN_URL_SUCCESS + "success";

      var form = document.createElement("form");
      form.method = "GET";
      form.action = urlstaoauthsuccess;

      var localtoken = document.createElement("input");
      localtoken.name = "msg";
      localtoken.value = msg;
      localtoken.type = "hidden";
      form.appendChild(localtoken);

      document.body.appendChild(form);
      form.submit();
    },

    msgError(text) {
      this.showMessageError = true;
      this.textError = text;
    },
    msgSuccess(text) {
      this.showMessageSuccess = true;
      this.textSuccess = text;
    },
    async getPolicyUrl(url) {
      let c = null;
      await axios.get(url).then((response) => {
        if (response.status == 200) {
          let key = keys(response.data.notices);
          let content = response.data.notices[key[0]].content;
          c = content;
        }
      });
      return c;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.scroll-area {
  position: relative;
  margin: auto;
  height: 500px;
}
.select {
  max-width: 100px;
}

.inputPrice >>> input[type="number"] {
  -moz-appearance: textfield;
}
.inputPrice >>> input::-webkit-outer-spin-button,
.inputPrice >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>
